
import {
  primary,
  grey,
} from '../../utils/brandColors';

const defaultOption = {
  paddingRight: 4,
  paddingLeft: 4,
  paddingTop: '.75em',
};

export default () => ({
  mention: {
    color: primary[600],
    position: 'relative',
    zIndex: 1,
    textShadow: '1px 1px 1px white, 1px -1px 1px white, -1px 1px 1px white, -1px -1px 1px white',
    pointerEvents: 'none',
  },
  highlightedOption: {
    ...defaultOption,
    backgroundColor: grey[300],
  },
  option: { ...defaultOption },
});
